/* ==========================================================================
   VITAL VIAL - Floating scroll cue
   One control on the left edge: a hairline with a circular arrow. It reads
   as "scroll down" on arrival and flips to "back to top" once you move.
   ========================================================================== */
(function () {
  'use strict';

  var cue = document.querySelector('[data-vv-scrollcue]');
  if (!cue) return;

  var btn = cue.querySelector('[data-vv-scrollcue-btn]');
  if (!btn) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var flipAfter = parseInt(cue.getAttribute('data-reveal-after'), 10);
  if (isNaN(flipAfter)) flipAfter = 240;

  var labelDown = btn.getAttribute('data-label-down') || 'Scroll down';
  var labelUp = btn.getAttribute('data-label-up') || 'Back to top';
  var isUp = false;

  function scrollTo(y) {
    window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  btn.addEventListener('click', function () {
    if (isUp) {
      scrollTo(0);
    } else {
      // Move on by one screen, which lands cleanly on the next section
      // without guessing at anchors.
      scrollTo((window.scrollY || window.pageYOffset) + window.innerHeight * 0.9);
    }
  });

  var ticking = false;
  function update() {
    var y = window.scrollY || window.pageYOffset;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var next = y > flipAfter;

    // At the very foot of the page there is nowhere further down to go.
    if (max > 0 && max - y < 80) next = true;

    if (next !== isUp) {
      isUp = next;
      cue.classList.toggle('is-up', isUp);
      btn.setAttribute('aria-label', isUp ? labelUp : labelDown);
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

/* ==========================================================================
   VITAL VIAL - Anchor links
   1. Offsets every #anchor landing by the sticky header height, so the
      heading is never hidden under the header.
   2. Lets a link use a section's key from the page template as its anchor
      (e.g. /pages/standards#spec lands on the "spec" section), so sections
      do not need a hand-made id to be linkable.
   3. Re-checks the landing position once images have loaded, unless the
      visitor has already started scrolling.
   #launch is left alone: it opens the newsletter popup (vv-popup.js).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerHeight() {
    var h = 0;
    var els = document.querySelectorAll('[id^="shopify-section-"][id$="__header"]');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && cs.display !== 'none') {
        h = Math.max(h, els[i].offsetHeight);
      }
    }
    return h;
  }

  function setOffset() {
    var h = headerHeight();
    root.style.scrollPaddingTop = (h ? h + 16 : 16) + 'px';
  }

  function idFromHash(hash) {
    if (!hash || hash.length < 2) return '';
    try { return decodeURIComponent(hash.slice(1)); } catch (e) { return ''; }
  }

  function nativeTarget(id) {
    return document.getElementById(id) || document.getElementsByName(id)[0] || null;
  }

  function sectionTarget(id) {
    var secs = document.querySelectorAll('[id^="shopify-section-"]');
    var suffix = '__' + id;
    for (var i = 0; i < secs.length; i++) {
      var sid = secs[i].id;
      if (sid.length > suffix.length && sid.slice(-suffix.length) === suffix) return secs[i];
    }
    return null;
  }

  function findTarget(id) {
    if (!id || id === 'launch') return null;
    return nativeTarget(id) || sectionTarget(id);
  }

  function go(el, smooth) {
    setOffset();
    el.scrollIntoView({ block: 'start', behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
  }

  setOffset();
  window.addEventListener('resize', setOffset, { passive: true });

  var userMoved = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
    window.addEventListener(type, function () { userMoved = true; }, { passive: true, once: true });
  });

  var initial = findTarget(idFromHash(window.location.hash));
  if (initial) {
    go(initial, false);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { if (!userMoved) go(initial, false); }, { once: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    var here = new URLSearchParams(window.location.search).get('view') || '';
    if ((url.searchParams.get('view') || '') !== here) return;
    var id = idFromHash(url.hash);
    if (!id || id === 'launch' || nativeTarget(id)) { setOffset(); return; }
    var target = sectionTarget(id);
    if (!target) return;
    e.preventDefault();
    go(target, true);
    if (window.history && window.history.pushState) window.history.pushState(null, '', url.hash);
  });
})();
